import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class BedroomService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('bedroom/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('bedroom/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('bedroom/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('bedroom/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('bedroom/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('bedroom/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('bedroom/delete', val_id);
  }
}
